import { useFirebaseActions } from '../services/auth/firebase/FirebaseAuthProvider';
import { useSelector } from 'react-redux';

export const useAuthUser = () => {
  let authData = useSelector((state) => state.auth);

  if (!authData?.user) {
    authData.user = JSON.parse(localStorage.getItem('user'));
  }
  return {
    isLoading: false,
    isAuthenticated: !!localStorage.getItem('token'),
    user: authData.user,
  };
};

export const useAuthMethod = () => {
  const {
    logInWithEmailAndPassword,
    registerUserWithEmailAndPassword,
    logInWithPopup,
    logout,
  } = useFirebaseActions();

  return {
    logInWithEmailAndPassword,
    registerUserWithEmailAndPassword,
    logInWithPopup,
    logout,
  };
};
